import { SUCCESS_STATUS, FAILURE_STATUS } from 'modules/application/misc/SegmentService';
import { CONFIGURATIONS_CHATBOT_EDITED, CONFIGURATIONS_CHATBOT_DELETED, CONFIGURATIONS_BASICS_OPENED, CONFIGURATIONS_WELCOME_SCREEN_OPENED, CONFIGURATIONS_CONNECTION_INFO_OPENED, CONFIGURATIONS_CONNECTION_BUILDER_TOGGLED, CONFIGURATIONS_CONNECTION_SDK_TOGGLED, CONFIGURATIONS_CONNECTION_HTTP_TOGGLED, DELETE_CHATBOT, } from './ConfigurationsSegmentEvents';
export class ConfigurationsSegmentService {
    static $inject = ['SegmentService'];
    constructor(SegmentService) {
        this.SegmentService = SegmentService;
    }
    setApplication(application) {
        this.application = application;
    }
    trackChatbotEdited(payload, success) {
        this.trackEvent(CONFIGURATIONS_CHATBOT_EDITED, payload, success);
    }
    trackChatbotDeleted(payload, success) {
        this.trackEvent(CONFIGURATIONS_CHATBOT_DELETED, payload, success);
    }
    trackBasicsOpened(payload, success) {
        this.trackEvent(CONFIGURATIONS_BASICS_OPENED, payload, success);
    }
    trackWelcomeScreenOpened(payload, success) {
        this.trackEvent(CONFIGURATIONS_WELCOME_SCREEN_OPENED, payload, success);
    }
    trackConnectionInfoOpened(payload, success) {
        this.trackEvent(CONFIGURATIONS_CONNECTION_INFO_OPENED, payload, success);
    }
    trackConnectionBuilderToggled(payload, success) {
        this.trackEvent(CONFIGURATIONS_CONNECTION_BUILDER_TOGGLED, payload, success);
    }
    trackConnectionSDKToggled(payload, success) {
        this.trackEvent(CONFIGURATIONS_CONNECTION_SDK_TOGGLED, payload, success);
    }
    trackConnectionHTTPToggled(payload, success) {
        this.trackEvent(CONFIGURATIONS_CONNECTION_HTTP_TOGGLED, payload, success);
    }
    trackOldChatbotDeleted(payload, success) {
        this.trackEvent(DELETE_CHATBOT, payload, success);
    }
    trackUserProperty(payload) {
        this.SegmentService.setAccount(payload);
    }
    trackEvent(event, payload, success) {
        this.SegmentService.createBotTrack(event, this.application, payload);
    }
    eventStatus(success) {
        if (success === undefined) {
            return;
        }
        return success ? SUCCESS_STATUS : FAILURE_STATUS;
    }
}
ConfigurationsSegmentService.$inject = ['SegmentService'];
